import type { ReactNode } from 'react'

import { IconCheck } from '@tabler/icons-react'

import { cn } from '@/lib/utils'

interface DrawerMenuItemProps {
  icon: ReactNode
  label: ReactNode
  isSelected?: boolean
  trailing?: ReactNode
  variant?: 'default' | 'destructive'
  onClick: () => void
}

export function DrawerMenuItem({
  icon,
  label,
  isSelected,
  trailing,
  variant = 'default',
  onClick,
}: DrawerMenuItemProps) {
  return (
    <button
      type="button"
      aria-pressed={isSelected}
      onClick={onClick}
      className={cn(
        "hover:bg-accent flex w-full cursor-pointer items-center gap-2 rounded-sm p-2 text-left text-sm [&_svg:not([class*='size-'])]:size-4",
        variant === 'destructive' &&
          'text-destructive hover:bg-destructive/10 dark:hover:bg-destructive/20',
      )}
    >
      {icon}
      <span className="flex-1">{label}</span>
      {isSelected && <IconCheck className="size-4" />}
      {trailing}
    </button>
  )
}
